import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";


import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
//import CustomInput from "components/CustomInput/CustomInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout } from "common/SharedFn";
import { getFaqQuestions,deleteFaqQuestion,addFaqQuestion,updateFaqQuestion } from "../../network/ApiAxios";
import { ArrowBack, Delete, Edit } from "@material-ui/icons";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const FaqTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [questionEn, setQuestionEn] = useState("");
  const [questionAr, setQuestionAr] = useState("");
  const [answerEn, setAnswerEn] = useState("");
  const [answerAr, setAnswerAr] = useState("");
  const [categoryId, setCategoryId] = useState(0);
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [executeDelete, setExecuteDelete] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  var currentCategoryId = props.match.params.id;
  let history = useHistory();

  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const setCurrentRecord = (info) => {
    const { id, questionEn, questionAr, answerEn, answerAr, categoryId } = info;
    setQuestionEn(questionEn);
    setQuestionAr(questionAr);
    setAnswerEn(answerEn);
    setAnswerAr(answerAr);
    setCategoryId(categoryId);
    setId(id);
  };

  const clearCurrentRecord = () => {
    setQuestionAr('');
    setQuestionEn('');
    setAnswerEn('');
    setAnswerAr('');
    setCategoryId();
    setId();
  };

  const fetchFaq = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getFaqQuestions(currentCategoryId);
    const { data } = response;
    if (data.result.isSuccess) {
      setData(data.data.map((prop) => makeTableRow(prop)));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch faq questions");
    }
    setIsLoading(false);
  };



  const addFaqQuestionCall = async () => {
    setIsLoading(true);
    try{
    const response = await addFaqQuestion(questionEn,questionAr,answerEn,answerAr,currentCategoryId);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Faq Added Successfully");
      setAddModal(false);
      setForceRefresh(true);
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to add faq");
      setIsLoading(false);
    }
  };


  const updateFaqQuestionCall = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try{
    const response = await updateFaqQuestion(id,questionEn,questionAr,answerEn,answerAr,currentCategoryId);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Faq Updated Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update faq");
      setIsLoading(false);
    }
  };


  const deleteFaq = async () => {
    setExecuteDelete(false);
    setIsLoading(true);
    try{
    const response = await deleteFaqQuestion(id);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Faq Deleted Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to delete faq");
      setIsLoading(false);
    }
  };

  useAsyncEffect(async () => {
    if(executeUpdate){
        updateFaqQuestion();
    }
    else if(executeDelete){
      deleteFaq();
    }
    else{
      fetchFaq();
    }
  }, [executeUpdate,forceRefresh,executeDelete]);

  const makeTableRow = (info) => {
    return {
      ...info,
      actions: (
        <div className="actions-right">
          <Tooltip title="Edit">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedWarning,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                setCurrentRecord(info);
                setAddModal(true);
            }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>
          <div style={{ display: "inline-block" }}>
          <Tooltip title="Delete">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedError,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Delete Question","Are you sure you would like to delete the faq with id "+info.id+"?",async () =>  {
                    setCurrentRecord(info);
                    setAlert(null);
                    setExecuteDelete(true);
                  })}}
                >
                  <Box component={Delete} />
                </Button>
              </Tooltip>
              </div>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Tooltip title="Back">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedPrimary,
                  }} 
                  variant="contained" 
                  style={{ marginRight: "20px" }}
                  onClick={() => {
                    history.goBack();
            }}>
              <Box component={ArrowBack} />
            </Button>
          </Tooltip>
                      <Box component="span">Frequently Asked Questions - Category {currentCategoryId}</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              <div style={{width: "100%"}}>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "id",
                    text: "ID",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "questionEn",
                    text: "Question (English)",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "questionAr",
                    text: "Question (Arabic)",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "answerEn",
                    text: "Answer (English)",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "answerAr",
                    text: "Answer (Arabic)",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                    //filter: textFilter()
                  },
                  {
                    dataField: "actions",
                    text: "Actions",
                    csvExport: false,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ marginBottom: "15px" }}
                      >
                        <Tooltip
                          title="Add new faq question"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedPrimary,
                            }}
                            onClick={() => {
                              clearCurrentRecord();
                              setAddModal(true);}}
                          >
                            <span>Add</span>
                          </Button>
                        </Tooltip>

                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                          <ExportCSVButton
                            className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                            {...props.csvProps}
                          >
                            <span className="MuiButton-label">Download</span>
                          </ExportCSVButton>
                        {/* </Tooltip> */}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      //filter={ filterFactory() }
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                    
                  </div>
                )}
              </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={addModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAddModal(false)}
              >
                <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    {id == null || id === "" ? "Add" : "Edit"} Faq Question
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>
                <FormGroup>
                  <FormLabel>Question (English)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Question (English)"
                    value={questionEn ?? ""}
                    multiline={true}
                    rows={5}
                    onChange={(e) => setQuestionEn(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Question (Arabic)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Question (Arabic)"
                    value={questionAr ?? ""}
                    multiline={true}
                    rows={5}
                    onChange={(e) => setQuestionAr(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Answer (English)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Answer (English)"
                    value={answerEn ?? ""}
                    multiline={true}
                    rows={5}
                    onChange={(e) => setAnswerEn(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Answer (Arabic)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Answer (Arabic)"
                    value={answerAr ?? ""}
                    multiline={true}
                    rows={5}
                    onChange={(e) => setAnswerAr(e.target.value)}
                  />
                </FormGroup>
                  </form>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setAddModal(false)}
                  >
                    Cancel
                  </Button>
                  
                    <Button
                      onClick={() =>
                        id == null || id === "" ? addFaqQuestionCall() : updateFaqQuestionCall()
                      }
                      
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }}
                      variant="contained"
                    >
                      {id == null || id === "" ? "Add" : "Update"}
                    </Button>
                  
                </DialogActions>
              </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default FaqTable;
